import React from 'react'

export const PlusIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="#fff"
        d="M9.005 18A9.06 9.06 0 0 0 18 8.995 9.066 9.066 0 0 0 8.995 0 9.058 9.058 0 0 0 0 8.995 9.067 9.067 0 0 0 9.005 18Zm0-1.605a7.365 7.365 0 0 1-7.391-7.4 7.367 7.367 0 0 1 7.38-7.4 7.39 7.39 0 0 1 7.408 7.4 7.368 7.368 0 0 1-7.397 7.4Zm-.02-3.231a.755.755 0 0 0 .77-.855V9.766h2.696a.752.752 0 0 0 .854-.752.753.753 0 0 0-.854-.78H9.755V5.543a.756.756 0 0 0-.77-.854.758.758 0 0 0-.762.854v2.693H5.54a.765.765 0 0 0-.864.78.764.764 0 0 0 .864.751h2.683v2.544a.758.758 0 0 0 .762.854Z"
      />
    </svg>
  )
}

export const ThreeDotsIcon = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24}
    height={24}
    viewBox="0 0 52 52"
    {...props}
  >
    <path fill="#CFD5D7" d="M8 20c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zm18 0c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zm18 0c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6z" />
  </svg>
  )
}

export const BackIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={11}
      height={13}
      fill="none"
      {...props}
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.34 1 1.002 6.707l8.338 4.735"
      />
    </svg>
  )
}

export const SendIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17}
      height={17}
      fill="none"
      {...props}
    >
      <path
        fill="#fff"
        d="M10.083 16.255c.58 0 .99-.48 1.289-1.226l5.275-13.275c.145-.357.226-.675.226-.94 0-.504-.323-.814-.846-.814-.274 0-.604.078-.975.217L1.2 5.33C.523 5.58 0 5.974 0 6.54c0 .715.564.955 1.337 1.18l4.349 1.273c.515.155.805.14 1.152-.171L15.673.869a.222.222 0 0 1 .306-.008c.08.078.088.194-.009.295L7.748 9.7c-.314.318-.339.582-.186 1.101l1.281 4.097c.242.784.491 1.358 1.24 1.358Z"
      />
    </svg>
  )
}

export const DownloadIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={17}
      fill="none"
      {...props}
    >
      <path
        fill="#333945"
        d="M2.525 16.992h8.649c1.686 0 2.525-.832 2.525-2.48V7.314c0-1.022-.123-1.466-.774-2.116L8.437.753C7.82.135 7.305 0 6.393 0H2.525C.847 0 0 .84 0 2.489V14.51c0 1.657.839 2.481 2.525 2.481Zm.057-1.276c-.84 0-1.27-.436-1.27-1.228V2.512c0-.784.43-1.236 1.278-1.236h3.624v4.605c0 .998.513 1.49 1.531 1.49h4.642v7.117c0 .792-.431 1.228-1.278 1.228H2.582Zm5.31-9.542c-.326 0-.448-.127-.448-.444V1.522l4.691 4.652H7.892Z"
      />
      <path
        fill="#333945"
        d="M4.473 11.5c-.334 0-.578.23-.578.547a.54.54 0 0 0 .211.428l2.321 2.076c.171.15.294.206.456.206.163 0 .286-.055.457-.206l2.32-2.076a.532.532 0 0 0 .204-.428c0-.317-.252-.547-.578-.547a.607.607 0 0 0-.432.182l-.708.705-1.165 1.165h-.203L5.62 12.387l-.717-.705a.607.607 0 0 0-.431-.182Zm2.41-3.146c-.333 0-.627.261-.627.586v2.853l.09 1.91c.033.682 1.042.682 1.075 0l.081-1.91V8.94c0-.325-.285-.586-.619-.586Z"
      />
    </svg>
  )
}

export const MagicIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17}
      height={17}
      fill="none"
      {...props}
    >
      <path
        fill="#333945"
        d="M11.25 5.825c.113 0 .201-.08.225-.201.354-1.81.595-2.205 2.47-2.478.128-.016.208-.113.208-.226a.23.23 0 0 0-.209-.24C12.07 2.405 11.75 1.97 11.475.216 11.451.08 11.363 0 11.25 0c-.128 0-.217.08-.241.21-.354 1.793-.595 2.196-2.46 2.47a.232.232 0 0 0-.218.24c0 .113.08.202.217.226 1.866.273 2.18.668 2.461 2.47.016.128.096.209.241.209Zm-8.966 6.597c.12 0 .2-.08.217-.193.241-1.512.241-1.625 1.882-1.883.112-.016.193-.088.193-.209 0-.12-.08-.193-.193-.209-1.64-.257-1.64-.37-1.882-1.883-.016-.112-.097-.193-.217-.193-.113 0-.193.08-.21.193-.24 1.513-.24 1.626-1.881 1.883-.113.016-.193.088-.193.21 0 .12.08.192.193.208 1.64.258 1.64.37 1.882 1.883.016.113.096.193.209.193Zm2.686 2.269c.096 0 .16-.073.185-.169.144-.893.104-.933 1.126-1.118.096-.024.16-.097.16-.185a.189.189 0 0 0-.16-.185c-1.014-.186-.965-.21-1.126-1.127-.024-.088-.097-.16-.185-.16-.097 0-.161.072-.185.176-.193.901-.113.95-1.118 1.11-.105.017-.169.09-.169.186 0 .088.064.16.16.185 1.014.185.934.225 1.127 1.118.024.096.088.169.185.169ZM14.235 15.592a.895.895 0 0 0 1.279 0 .911.911 0 0 0-.008-1.28L5.228 4.03a.888.888 0 0 0-1.278 0 .901.901 0 0 0 .008 1.271l10.277 10.29ZM7.271 7.747 4.505 4.972a.272.272 0 0 1 0-.395.279.279 0 0 1 .394 0l2.774 2.784-.402.386Z"
      />
    </svg>
  )
}

export const NoteIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width={12}
      height={12}
      viewBox="0 0 64 64"
      {...props}
    >
      <path
        fill="#808f94"
        fillRule="evenodd"
        d="M60 0H4C1.789 0 0 1.789 0 4v40c0 2.211 1.789 4 4 4h8v12a3.996 3.996 0 0 0 4 4 3.998 3.998 0 0 0 2.828-1.172L33.656 48H60c2.211 0 4-1.789 4-4V4c0-2.211-1.789-4-4-4z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export const EditIcon = (props) => {
  return (
    <svg focusable="false" width={14.487} height={14.797} viewBox="0 0 14.487 14.797" aria-hidden="true" {...props}>
      <path fill="#808F95" id="Label_Right" data-name="Label Right" d="M15.026,2.376l.527-.542a.585.585,0,0,0,.007-.857L15.392.8a.583.583,0,0,0-.828.037l-.535.527ZM6.6,9.994l1.428-.623,6.46-6.46-1-.989L7.028,8.382,6.369,9.759A.182.182,0,0,0,6.6,9.994Zm-3.04,5.449h8.6c1.311,0,2.08-.762,2.08-2.271V5.021L13.056,6.2v6.914c0,.762-.417,1.15-.923,1.15H3.571a1.022,1.022,0,0,1-1.135-1.15V4.8A1.027,1.027,0,0,1,3.571,3.644H9.906l1.179-1.179H3.556a2.023,2.023,0,0,0-2.3,2.271v8.438A2.02,2.02,0,0,0,3.556,15.443Z" transform="translate(-1.256 -0.646)"></path>
    </svg>
  )
}

export const CrossIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M19 5 5 19M5 5l14 14"
      />
    </svg>
  )
}

export const ExcelIcon = (props) => {
  return (
    <svg focusable="false" viewBox="0 0 24.929 23.601" aria-hidden="true">
      <defs>
        <radialGradient id="radial-gradient" cx="6.02" cy="25.157" r="0.39" gradientTransform="translate(-3.837 -22.366) scale(1.661 1.921)" gradientUnits="objectBoundingBox">
          <stop offset="0" stop-color="#237f4c"></stop>
          <stop offset="1" stop-color="#1e6c41"></stop>
        </radialGradient>
      </defs>
      <rect id="rect4556" width="23.35" height="18.313" rx="3.375" transform="translate(1.23 2.582)" fill="#fff"></rect>
      <g id="use3985" transform="translate(13.449 2.344)">
        <path id="rect3991" d="M103.389-46.454h3.983v2.046h-3.983Zm4.8,0h3.983v2.042h-3.983Zm-4.8-2.966h3.983v2.144h-3.983Zm4.8,0h3.983v2.144h-3.983Zm-4.8-2.961h3.983v2.144h-3.983Zm4.8,0h3.983v2.144h-3.983Zm-4.8-2.961h3.983V-53.2h-3.983Zm4.8,0h3.983V-53.2h-3.983Zm-4.8-2.961h3.983v2.144h-3.983Zm4.8,0h3.983v2.144h-3.983Zm-4.938-2.447v.813h10.658v17.262H103.25v.817h10.59a.889.889,0,0,0,.889-.889V-59.862a.889.889,0,0,0-.889-.889H103.25Z" transform="translate(-103.25 60.751)" fill="#1f7144"></path>
      </g>
      <path id="path3945" d="M18.68,9.063,4.469,11.59V30.1l14.2,2.566Zm-4.544,7.616L12.1,20.861l2.089,4.208L12.3,24.958l-1.242-3.08-1.217,2.94-1.664-.094,1.953-3.863L8.277,16.955l1.8-.085,1.047,2.846,1.259-2.957Z" transform="translate(-4.469 -9.063)" fill="url(#radial-gradient)"></path>
    </svg>
  )
}

export const PencilIcon = (props) => {
  return (
    <svg width="8" height="8" fill="none">
      <path fill="#fff" fill-opacity="0.85" d="m1.333 6.842 5.325-4.998-.854-.807-5.33 4.998-.463 1.022c-.05.11.078.239.195.193l1.127-.408ZM7.087 1.45 7.58.996C7.83.762 7.844.51 7.62.3L7.452.143c-.22-.206-.488-.188-.737.042l-.493.458.864.807Z">
        </path>
    </svg>
  )
}

export const EyeIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27.051 16.748"
      width={17}
      height={17}
      {...props}
    >
      <path
        fill="#fff"
        d="M13.35 16.748c7.89 0 13.34-6.377 13.34-8.37C26.69 6.378 21.23.01 13.35.01 5.566.01 0 6.377 0 8.379c0 1.992 5.557 8.369 13.35 8.369Zm0-1.543c-6.436 0-11.641-5.45-11.641-6.826 0-1.162 5.205-6.826 11.64-6.826 6.407 0 11.631 5.664 11.631 6.826 0 1.377-5.224 6.826-11.63 6.826Zm0-1.367a5.476 5.476 0 0 0 5.478-5.479 5.476 5.476 0 0 0-5.478-5.478A5.485 5.485 0 0 0 7.86 8.359a5.485 5.485 0 0 0 5.489 5.479Zm0-3.652a1.813 1.813 0 0 1-1.817-1.817c0-1.006.81-1.816 1.817-1.816 1.005 0 1.816.81 1.816 1.816s-.81 1.816-1.816 1.816Z"
      />
    </svg>
  )
}